import React from 'react';
import {
  takeLatest, call, put, select,
} from 'redux-saga/effects';
import { api } from '@/utils/api';
import { config } from '@/config';
import logger from '@/utils/logger';
import { locale } from '@/utils/locale';
import { LOGOUT_URL } from '@/config/whmcsUrls';
import { commonActions } from '@/redux/modules/common';
import { SupergatorActionTypes } from './supergator.types';
import { supergatorActions } from '@/redux/modules';
import { submitJwtForm } from './supergator.utils';

const { WHMCS_URL } = config;

const DEFAULT_SSO_REDIRECT_PATH = '/';

function* requestSsoEmit({ payload = {} } = {}) {
  const { token, jwt: jwtToken } = yield select(state => state.auth);
  const started = Date.now();
  const redirectPath = payload.redirectPath ?? DEFAULT_SSO_REDIRECT_PATH;

  const request = {
    url: `${WHMCS_URL}/api/v3/ai-platform/sso/emit`,
    headers: {
      Authorization: `Bearer ${token}`,
      'x-service-token': jwtToken,
    },
    params: { redirect_path: redirectPath },
  };

  try {
    const response = yield call(api.whmcs.get, request);
    const { jwt, target_url: targetUrl, exp } = response.data.data;

    logger.info(SupergatorActionTypes.SSO_EMIT_SUCCESS, {
      elapsed_ms: Date.now() - started,
      exp,
    });

    try {
      yield call(submitJwtForm, jwt, targetUrl);
    } catch (validationError) {
      logger.error('SUPERGATOR_SSO_JWT_VALIDATION_FAILED', validationError, {
        reason: validationError.message,
      });
      yield put(commonActions.notifications.set({
        label: (<p>{locale('agents.sso.tokenValidationError')}</p>),
        type: 'error',
      }));
      yield put(supergatorActions.sso.failure({
        status: 0,
        message: validationError.message,
      }));
      return;
    }

    yield put(supergatorActions.sso.success());
  } catch (requestError) {
    const status = requestError?.response?.status || 0;
    const error = { ...requestError, userRequestData: request };

    logger.error(SupergatorActionTypes.SSO_EMIT_FAILURE, error, {
      status,
      reason: requestError.message,
    });

    if (status === 401) {
      window.location.href = LOGOUT_URL;
    } else {
      yield put(commonActions.notifications.set({
        label: (<p>{locale('agents.sso.unavailableError')}</p>),
        type: 'error',
      }));
    }

    yield put(supergatorActions.sso.failure({ status, message: requestError.message }));
  }
}

function* sagas() {
  yield takeLatest(SupergatorActionTypes.SSO_EMIT_REQUEST, requestSsoEmit);
}

export default sagas;
